import twenty_colors from "../../Data/twenty_colors.json";

const generate_array_color = function (array_name) {
  // Ensure the array_name is valid, fallback to empty array if not
  const processed_array =
    Array.isArray(array_name) && array_name.length > 0 ? array_name : [];

  // Check if st_colors exists and is an array
  if (!Array.isArray(twenty_colors) || twenty_colors.length === 0) {
    throw new Error("st_colors array is empty or not defined.");
  }

  // Generate the color array based on array_name length
  let color_array = processed_array.map((e, idx) => {
    const index = idx % twenty_colors.length; // Safely map to st_colors
    return twenty_colors[index];
  });

  // Add the default color at the end
  color_array.push("#575757");

  return color_array;
};

export default generate_array_color;
